import React, { Component } from 'react';
import NavBar from '../Components/NavBar/NavBar.js';
import './Catalogo.css';
import Footer from '../Components/Footer/Footer.js';
import FooterContatos from '../Components/Footer/FooterContatos.js';
import ButtonC from '../Components/ButtonCatalogo/ButtonC';
import WEGP from '../Images/Catalogo/WEG.jpg';
import WEG2 from '../Images/Catalogo/WEG2.jpg';
import WEG3 from '../Images/Catalogo/WEG3.jpg';
import WEG4 from '../Images/Catalogo/WEG4.jpg';
import WEG5 from '../Images/Catalogo/WEG5.jpg';
import WEG6 from '../Images/Catalogo/WEG6.jpg';
import FloatingWhatsApp from 'react-floating-whatsapp';
import LOGOL from '../Images/logo2.png';



class Conversores extends Component {
 render() {
 return (
   <div className="backGBlack">
   <NavBar/>
    <div className="EspacoBotoes"></div>
  <div className="ButtonsItens">
  <ButtonC/>
     </div>
     <div className="EspacoBotoes"></div>
   <div className="CatalogoPageCss">
  
     <img src={WEGP} width="auto" alt="PRODUTOSWEG"></img>
     <img src={WEG2} width="auto" alt="PRODUTOSWEG2"></img>
     <img src={WEG3} width="auto" alt="PRODUTOSWEG3"></img>
     <img src={WEG4} width="auto" alt="PRODUTOSWEG4"></img>
     <img src={WEG5} width="auto" alt="PRODUTOSWEG5"></img>
     <img src={WEG6} width="auto" alt="PRODUTOSWEG6"></img>
     
   </div>
   <div className="EspacoBotoes"></div>
   <Footer/>
   <FooterContatos/>
   <FloatingWhatsApp avatar={LOGOL} position="absolute" accountName="Centro Oeste" allowClickAway="true" placeholder="Escreva sua mensagem"  chatMessage="Olá, como posso te ajudar?" statusMessage="online" allowEsc="true" phoneNumber="5567998383492"/>
</div>
 );
 }
}
export default Conversores;